import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';

function InwardView(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [reqHeader, setReqHeader] = useState([]);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {

            setReqHeader(props.rhdata.data[0]);


            setOnceRun(true);
        }
    }, [onceRun, props]);

    function getStatusName(v) {
        switch (v) {
            case 'NEW':
                return 'NEW';
            case 'PBC':
                return 'Waiting for Confirmation';
            case 'PBT':
                return 'Pending Bank Transfer';
            case 'PRE':
                return 'Pending Reprocess';
            case 'REP':
                return 'Reprocessed';
            case 'RFA':
                return 'Refund Approved';
            case 'REF':
                return 'Refund Processed';
            default:
                return '';
        }
    }

    function getActionName(v) {
        switch (v) {
            case "PRE":
                return "Reprocess";
            case "PBT":
                return "Refund";
            default:
                return "";
        }
    }


    return (
        <>
            <Container fluid>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                {
                    props.rhdata.data !== undefined ?
                        <>
                            <Row>
                                <Col>
                                    Sr No : <b>{reqHeader.reqi_srno}</b>
                                </Col>
                                <Col>
                                    Issuer : <b>{reqHeader.issuer_name}</b>
                                </Col>
                                <Col>
                                    Status : <b>{getStatusName(reqHeader.reqi_status)}</b>
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col>
                                    Date : <b>{reqHeader.reqi_datedmy}</b>
                                </Col>
                                <Col>
                                    ISD : <b>{reqHeader.reqi_isd}</b>
                                </Col>
                                <Col>
                                    Quantity : <b>{reqHeader.reqi_quantity}</b>
                                </Col>
                                <Col>
                                    Location : <b>{reqHeader.reqi_branchname}</b>
                                </Col>
                            </Row>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col>
                                    Inward Reference : <b>{reqHeader.reqi_inwardrefno}</b>
                                </Col>
                                <Col>
                                    Zenith Reference : <b>{reqHeader.reqi_zenithrefno}</b>
                                </Col>
                            </Row>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col>
                                    Issuer Comment : <b>{reqHeader.reqi_issuercomment}</b>
                                </Col>
                            </Row>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col xs={6} >
                                    Branch Confirmation : <b>{getActionName(reqHeader.reqi_branchconfirmstatus)} : {reqHeader.reqi_branchconfirmremark}</b>
                                </Col>
                                {
                                    reqHeader.reqi_branchconfirmstatus === "PRE" ? <>
                                        <Col>
                                            Reporcess Quantity : <b>{reqHeader.reqi_branchreprocessquantity}</b>
                                        </Col>
                                        <Col>
                                            Balance Cover : <b>{(reqHeader.reqi_branchreprocessquantity) * 1 - (reqHeader.reqi_quantity) * 1}</b>
                                        </Col>
                                    </> : null
                                }
                            </Row>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col>
                                    {
                                        reqHeader.reqi_paymentcredited === "1" && reqHeader.reqi_branchconfirmstatus === "PBT" ? <>
                                            <b>
                                                INR : {reqHeader.reqi_paymentcreditamount} Received on : {reqHeader.reqi_paymentcreditdatedmy}&nbsp;
                                                wide reference number : {reqHeader.reqi_paymentcreditrefno}&nbsp;
                                            </b>
                                        </> : <>
                                            <b>Payment Credit information not found</b>
                                        </>
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>

                            <Row className='border-bottom'>
                                <Col>&nbsp;</Col>
                            </Row>
                        </> : null
                }
            </Container>
        </>
    )
}
export default InwardView;